import PropTypes from 'prop-types';
import React from 'react';
import GoogleMapReact from 'google-map-react';
import MarkerBlip from './MarkerBlip';

class PlaceDetail extends React.Component {

  render() {
    const centerXY = {
      lat: this.props.place.position.coordinates[1],
      lng: this.props.place.position.coordinates[0],
    };
    return (
      <div>
        <div>
          <div>
            {this.props.place.name}
            <div className="pull-left">
              <a href={this.props.place.website} title={this.props.place.website} >
                <span className={this.props.place.website ? 'fa fa-external-link' : 'hidden'} /></a>
            </div>
          </div>
          <div className="clearfix" />
        </div>
        <div className="place-details text-muted">
          <p><i className="fa fa-map-marker" />
            {this.props.place.address}
            <br />
            {this.props.place.city},
            &nbsp;
            {this.props.place.state}
            {this.props.place.postcode && (
              `, ${this.props.place.postcode}`
            )}
          </p>
          {this.props.place.tel && (
            <p><i className="fa fa-phone" />
              <a href={`tel:${this.props.place.tel}`}>{this.props.place.tel}</a>
            </p>
          )}
        </div>
      </div>
    );
  }
}

PlaceDetail.propTypes = {
  place: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};

PlaceDetail.defaultProps = {
  place: {
    selected: false,
  },
};
export default PlaceDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/PlaceDetail.js